import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Adblock } from '../../index';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 id="component">Adblock</h1>A component to tell if the user has adblock enabled or not.
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={1} __code={'<Adblock>\n  {({ blocked }) => <span>{blocked ? \'Blocked!\' : \'Not blocked\'}</span>}\n</Adblock>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Adblock,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Adblock mdxType="Adblock">{({
          blocked
        }) => <span>{blocked ? 'Blocked!' : 'Not blocked'}</span>}</Adblock>
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <p>{`Adblock accepts only one child which must be a function.`}</p>
    <Props of={Adblock} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      